import { render } from "./pet.vue?vue&type=template&id=2d0346c1&scoped=true"
import script from "./pet.vue?vue&type=script&lang=js"
export * from "./pet.vue?vue&type=script&lang=js"

import "./pet.vue?vue&type=style&index=0&id=2d0346c1&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0346c1"]])

export default __exports__